module.exports = __webpack_public_path__ + "static/media/kitaseocovid.2204f364.jpg";